import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { useRef } from "react";
import { useCallback } from "react";
import { RECTIFIER_FETCH_START } from "../../Reducer/RectifierSlice";
import Agent from "../../Network/Agent";
import { toast } from "react-hot-toast";

export default function RectifierIndex() {
    const selector = useSelector((state) => state.rectifierReducer)
    const [page, setPage] = useState(1);
    const [brand_id, setBrand] = useState('');
    const [site_id, setSiteId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [exporting, setExporting] = useState(false);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    const observer = useRef();

    const handleBrandChange = (e) => {
        const value = e.target.value;
        setBrand(value);

        // Remove brand from search params if manually selected
        if (searchParams.has("brand")) {
            setSearchParams({});
        }
    };

    function FormattedNumber(number = 0) {

        const formatted = number.toLocaleString(); // or Intl.NumberFormat().format(number)

        return formatted;
    }
    const array_data = {
        'site_id': '',
        'brand_id': '',
        'page': page,
        'tenant_id': 'tenant_id',
    };

    const buildArrayData = () => {
        const data = {
            site_id,
            page,
            tenant_id,
            brand_id: '',
        };

        if (brand_id !== '') {
            data.brand_id = brand_id;
        } else {
            const brandQuery = searchParams.get("brand");
            if (brandQuery) {
                data.brand_id = brandQuery;
                // setBrand(brandQuery); // Optional sync
            }
        }

        return data;
    };

    useEffect(() => {
        const data = buildArrayData();

        dispatch(RECTIFIER_FETCH_START());

        const loadMore = page !== 1;
        Agent.RECTIFIER.get_rectifier(dispatch, data, loadMore);

    }, [page, site_id, tenant_id, brand_id]); // ✅ Remove searchParams from dependencies

    
    const lastElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();

        // if there's no more data to be fetched, don't set new observer
        if (!selector?.data.has_more_page) return;

        // set new observer
        observer.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && selector?.data.has_more_page) setPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) observer.current.observe(element);
    }, [selector?.data.has_more_page]);


    const syncData = (name) => {
        setSiteId(name);
    }

    const resetData = () => {

        array_data.site_id = '';
        array_data.page = 1;
        array_data.tenant_id = '';
        array_data.brand_id = '';

        setSiteId('');
        setTenantId('');
        setPage(1);
        setBrand('');

        setSearchParams({});
        // window.history.replaceState(null, '', '/rectifier_monitoring');
        //  dispatch(RECTIFIER_FETCH_START())
        // Agent.RECTIFIER.get_rectifier(dispatch, array_data, false)

    }

    const exportCsv = () => {
        if (exporting) return;
        setExporting(true);
        const toastId = toast.loading("Exporting CSV...");
        Agent.RECTIFIER.export(buildArrayData())
            .then((response) => {
                const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "rectifier_monitoring.csv");
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                toast.success("CSV downloaded", { id: toastId });
            })
            .catch(() => toast.error("Export failed", { id: toastId }))
            .finally(() => setExporting(false));
    };

    const strAscending = selector?.sites.length > 0 && [...selector?.sites].sort((a, b) =>
        a.site_id > b.site_id ? 1 : -1,
    );
    const selector_rectifier = useSelector((state) => state.rectifierReducer)

    return (
        <>
            <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-2 mt-2 me-1 ms-1">
                <div className="input-group input-group-sm" style={{ maxWidth: 380 }}>
                    <input onChange={(e) => syncData(e.target.value)} type="text" className="form-control" placeholder="search by site id...." />
                    <select onChange={handleBrandChange} className="form-select form-select-sm">
                        <option value="" selected={brand_id === ''}>All Brand</option>
                        {!selector_rectifier?.loading &&
                            selector_rectifier?.rectifier_count?.map((brand, bIndex) => (
                                <option
                                    key={bIndex}
                                    value={brand?.rectifier_brand_id}
                                    selected={brand_id === brand?.rectifier_brand_id}
                                >
                                    {brand?.brand_name}
                                </option>
                            ))}
                    </select>
                </div>
                <button onClick={() => syncData('')} className="btn btn-warning btn-sm flex-shrink-0" type="button">
                    <i className="fa-light fa-refresh me-1" />Refresh
                </button>
                <button onClick={() => resetData()} className="btn btn-danger btn-sm flex-shrink-0" type="button">
                    <i className="fa-light fa-clear me-1" />Reset
                </button>
                <button onClick={exportCsv} className="btn btn-success btn-sm flex-shrink-0" type="button" disabled={exporting}>
                    <i className={`fa-light ${exporting ? "fa-spinner fa-spin" : "fa-file-export"} me-1`} />
                    {exporting ? "Exporting..." : "Export CSV"}
                </button>
            </div>

            <div className="table-responsive scrol-table-height">
                {selector?.loading ? <p className='text-center text-dark fw-medium'>Loading...</p> : ''}

                <table className="table table-bordered table-striped m-0 table-sm bg-white text-center">
                    <thead>
                        <tr className="text-uppercase">
                            <th className="text-center toi-primary" rowSpan={2}>Updated</th>
                            <th className="text-center toi-primary" rowSpan={2}>SITE ID</th>
                            <th className="text-center toi-primary" rowSpan={2}>Tenant SITE ID</th>
                            <th className="text-center toi-primary" rowSpan={2}>Rectifier Name</th>
                            <th className="text-center toi-primary" rowSpan={2}>Network</th>
                            <th className="text-center toi-primary w-20" rowSpan={2}>Mains Fail</th>
                            <th className="text-center toi-primary w-20" rowSpan={2}>DC Low</th>
                            <th className="text-center toi-primary w-20" rowSpan={2}>Module Fault</th>
                            <th className="text-center toi-primary w-20" rowSpan={2}>Fuse Fault</th>
                            <th className="text-center toi-primary w-20" rowSpan={2}>LLVD</th>
                            <th className="text-center toi-primary w-20" rowSpan={2}>BLVD</th>
                            <th className="text-center toi-primary" colSpan={2}>DC</th>
                            <th className="text-center toi-primary" colSpan={6}>Phase</th>
                            <th className="text-center toi-primary" rowSpan={2}>AC frequency</th>
                            <th className="text-center toi-primary" colSpan={2}>Cumulative Power</th>
                        </tr>
                        <tr>
                            <th className="text-center toi-primary">V</th>
                            <th className="text-center toi-primary">I</th>
                            <th className="text-center toi-primary">A(V)</th>
                            <th className="text-center toi-primary">B(V)</th>
                            <th className="text-center toi-primary">C(V)</th>
                            <th className="text-center toi-primary">A(I)</th>
                            <th className="text-center toi-primary">B(I)</th>
                            <th className="text-center toi-primary">C(I)</th>
                            <th className="text-center toi-primary">AC(kWh)</th>
                            <th className="text-center toi-primary">DC(kWh)</th>
                        </tr>
                    </thead>
                    <tbody>

                        {selector?.sites.length > 0 && strAscending?.map((site, index) => (
                            <tr className={`${site.device_live_status == 0 ? 'offline-tr' : ''}`} ref={index === selector?.sites.length - 1 ? lastElementRef : undefined}>
                                <td>
                                    <p className="m-0 p-0" style={{ fontSize: '12px', width: '150px' }}>{site.update_time}</p>

                                </td>

                                <td className="text-center">
                                    <Link className="fw-bold" to={`/site/${site.site_id}`}>{site.site_id}</Link>
                                </td>
                                <td className="text-center">
                                    <Link className="fw-bold" to={`/site/${site.site_id}`}>{site.customer_site_id}</Link>
                                </td>

                                <td className="text-center">
                                    <a className="text-warning text-underline-hover" href="#"> {site.name}</a>

                                </td>
                                <td className="text-center">
                                    {site.device_live_status === 1 ?
                                        <div className="signal-bars mt1 sizing-box good four-bars">
                                            <span>
                                                <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                                            </span>
                                            <div className={`first-bar bar ${site.network_val >= 1 ? '' : 'null-color'}`}>
                                            </div>
                                            <div className={`second-bar bar ${site.network_val >= 2 ? '' : 'null-color'}`}>
                                            </div>
                                            <div className={`third-bar bar ${site.network_val >= 3 ? '' : 'null-color'}`}>
                                            </div>
                                            <div className={`fourth-bar bar ${site.network_val >= 4 ? '' : 'null-color'}`}>
                                            </div>
                                            <div className={`fifth-bar bar ${site.network_val >= 5 ? '' : 'null-color'}`}>
                                            </div>
                                        </div>
                                        :
                                        <i class="fa-solid fa-wifi-slash offline-rms-icon" title="Site not updating" />
                                    }
                                </td>
                                <td className="text-center">
                                    <div className={`alarm_icon ${site.mains_fail == 1 ? 'A3' : 'A1'}`}>
                                        &nbsp;
                                    </div>
                                </td>
                                <td className="text-center">
                                    <div className={`alarm_icon ${site.dc_low == 1 ? 'A3' : 'A1'}`}>
                                        &nbsp;
                                    </div>
                                </td>
                                <td className="text-center">
                                    <div className={`alarm_icon ${site.rectifier_fault == 1 ? 'A3' : 'A1'}`}>
                                        &nbsp;
                                    </div>
                                </td>
                                <td className="text-center">
                                    <div className={`alarm_icon ${site.bat_load_fuse_fault == 1 ? 'A3' : 'A1'}`}>
                                        &nbsp;
                                    </div>
                                </td>
                                <td className="text-center">
                                    <div className={`alarm_icon   ${site.llvd == 1 ? 'A3' : 'A1'}`}>
                                        &nbsp;
                                    </div>
                                </td>
                                <td className="text-center">
                                    <div className={`alarm_icon   ${site.critical_disconnect == 1 ? 'A3' : 'A1'}`}>
                                        &nbsp;
                                    </div>
                                </td>
                                <td className="text-center">
                                    {site.dc_voltage}
                                </td>
                                <td className="text-center">
                                    {site.dc_current}
                                </td>
                                <td className="text-center">
                                    {site.pahse_avoltage}
                                </td>
                                <td className="text-center">
                                    {site.pahse_bvoltage}
                                </td>
                                <td className="text-center">
                                    {site.pahse_cvoltage}
                                </td>
                                <td className="text-center">
                                    {site.pahse_acurrent}
                                </td>
                                <td className="text-center">
                                    {site.pahse_bcurrent}
                                </td>
                                <td className="text-center">
                                    {site.pahse_ccurrent}
                                </td>
                                <td className="text-center">
                                    {site.ac_frequency}
                                </td>
                                <td className="text-center">
                                    {site.cum_ac_power}
                                </td>
                                <td className="text-center">
                                    {site.cum_dc_power}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {isLoading && <div className="text-center">Loading......</div>}
            </div>
            <p className="p-0 m-0 fs-12 mt-2">Current Display 1 - {selector?.sites?.length} Record(s), <span className="text-dark fw-bold">{FormattedNumber(selector?.data?.total_page)}</span> Record(s) Totally</p>

        </>
    )
}